import { render, staticRenderFns } from "./edit-question.component.html?vue&type=template&id=2f8058c6&scoped=true&"
import script from "./edit-question.component.ts?vue&type=script&lang=ts&"
export * from "./edit-question.component.ts?vue&type=script&lang=ts&"
import style0 from "./edit-question.component.scss?vue&type=style&index=0&id=2f8058c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8058c6",
  null
  
)

export default component.exports